import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { invalidateTruckShiftQueries } from 'src/hooks/invalidateTruckShiftQueries';

export const truncatePath = (id: number): string => `/api/v5/truck_shifts/${id}/truncate`;

export const useMutationTruckShiftTruncate = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ id, truncateOn }: { id: number; truncateOn: string }): Promise<void> => {
      await axios.patch(truncatePath(id), { truncate_on: truncateOn });
    },
    { onSuccess: () => { invalidateTruckShiftQueries(queryClient); } },
  );
};
